// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Form_text-gradient__2qnO6","form":"Form_form__3wvE7","input":"Form_input__1FXum","btn":"Form_btn__3oLO-"};